import { useState } from 'react';

function usePaginator() {
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(0);
    const [records, setRecords] = useState(0);
    const [regiPerPage, setRegiPerPage] = useState(15);

    const next = () => {
        setPage(prevPage => {
            const newPage = prevPage + 1;
            return newPage <= pages ? newPage : prevPage;
        });
    };

    const back = () => {
        setPage(prevPage => {
            const newPage = prevPage - 1;
            return newPage >= 1 ? newPage : prevPage;
        });
    };

    return {
        page,
        pages,
        records,
        regiPerPage,
        setRegiPerPage,
        setPage,
        setPages,
        setRecords,
        next,
        back
    };
}

export default usePaginator;
